import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import ReactQuill from 'react-quill';
import 'react-quill/dist/quill.snow.css'; // Import Quill styles
import ViewTradingServices from '../../../services/ViewTradingServices';


function AddWeabhook() {
  const [formData, setFormData] = useState({
    scannerType: '',
  });
  const navigate = useNavigate();
  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value.replace(/\s+/g, '') });
  };



  const handleSubmit = async (e) => {
    e.preventDefault();

    // Form data for file upload
    const data = new FormData();
    data.append('scannerType', formData.scannerType);

    try {
      const response = await ViewTradingServices.createWebhook(formData);
      alert('webhook added successfully!');
      navigate('/admin/webhook'); // Redirect to webhook list page
    } catch (error) {
      console.error('There was an error adding the webhook!', error);
      alert('Failed to add webhook. Please try again.');
    }
  };

  return (
    <div className="right_col" role="main">
      <div className="title-box">
        <h2>Stock Add</h2>
        <div className="container-box-top-header-right">
          <a className="list-banner-btn" href="/admin/webhook">
            Webhook List
          </a>
        </div>
      </div>
      <div className="container-box px-5">
        <div className="container-box-inner">
          <div className="page-details">
            <form onSubmit={handleSubmit}>
              <div className="row">
                <div className="col-md-6">
                  <div className="input-field">
                    <label>Scanner Type</label>
                    <input
                      type="text"
                      name="scannerType"
                      value={formData.scannerType}
                      onChange={handleInputChange}
                      onKeyDown={(e) => {
                        if (e.key === ' ') e.preventDefault();
                      }}
                      onPaste={(e) => {
                        const pastedText = e.clipboardData.getData('text');
                        if (/\s/.test(pastedText)) e.preventDefault();
                      }}
                      className="form-control"
                      required
                    />
                  </div>
                </div>
              </div>
              <button type="submit" className="submit-green-btn">
                SUBMIT
              </button>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
}

export default AddWeabhook;
